<script>
import Viewer from "viewerjs";
import 'viewerjs/dist/viewer.css';

export default ({
  props: {
    images: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loadedImages: 0,
      totalWidth: 0,
      scrollPosition: 0,
      animationFrameId: null,
    };
  },
  beforeUnmount() {
    cancelAnimationFrame(this.animationFrameId);
  },
  methods: {
    onImageLoad(refName, imgListName, loadedCountKey, totalWidthKey, positionKey, frameIdKey) {
      this[loadedCountKey]++;
      const carousel = this.$refs[refName];
      if (this[loadedCountKey] === this[imgListName].length * 2) {
        this[totalWidthKey] = Array.from(carousel.children).reduce((sum, img) => sum + img.offsetWidth, 0);
        this.startCarousel(carousel, positionKey, totalWidthKey, frameIdKey);
      }
    },
    startCarousel(carousel, positionKey, widthKey, frameIdKey) {
      const animate = () => {
        this[positionKey] -= 1.1;
        if (Math.abs(this[positionKey]) >= this[widthKey] / 2) this[positionKey] = 0;
        carousel.style.transform = `translateX(${this[positionKey]}px)`;
        this[frameIdKey] = requestAnimationFrame(animate);
      };
      animate();
    },
    onImageClick() {
      const carousel = this.$refs.carousel;
      const viewer = new Viewer(carousel, {
        toolbar: false,
        show() {
          viewer.update()
        }
      });

    }
  },
})
</script>

<template>
  <div class="carousel-container">
    <div ref="carousel" class="carousel images">
      <img
        v-for="(image, index) in [...images, ...images]"
        :key="`${image}:${index}`"
        :src="image.src"
        @click="onImageClick"
        @load="onImageLoad('carousel', 'images', 'loadedImages', 'totalWidth', 'scrollPosition', 'animationFrameId')"
      >
    </div>
  </div>
</template>

<style scoped lang="scss">
.carousel-container {
  overflow: hidden;
  position: relative;

  .carousel {
    display: flex;
    white-space: nowrap;

    img {
      height: 435px;
      margin-right: 10px;
      object-fit: cover;
      flex-shrink: 0;
    }
  }
}
</style>
